import React from 'react';

// Mention du développeur, affichée en bas de toutes les pages
const Footer = ({ className = 'app-footer' }) => (
  <footer className={className}>
    Développé par{' '}
    <a href="https://www.kfbusiness.ci" target="_blank" rel="noopener noreferrer">
      KF BUSINESS ET INFORMATIQUE
    </a>
  </footer>
);

export default Footer;
